import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

export default function EditorPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
    </Box>
  );
}
